import React, { Component } from "react";
import { Api } from "../../app-controller";

class InfoForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset>
            <legend>DATOS MOVIMIENTO</legend>

            <div className="row">
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Folio de movimiento:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.folio_movimiento ?? "N/A"
                      : null}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Folio de egreso:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.bitacora_producto_egreso
                          .folio_bitacora_producto ?? "N/A"
                      : null}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label>Folio de ingreso:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento &&
                    this.props.bitacora_movimiento.bitacora_producto_ingreso
                      ? this.props.bitacora_movimiento.bitacora_producto_ingreso
                          .folio_bitacora_producto ?? "N/A"
                      : "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-9">
                <div className="form-group">
                  <label>Establecimiento que envía:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.establecimiento_envia_nombre.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Actividad envía:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.actividad_envia.descripcion.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-9">
                <div className="form-group">
                  <label>Establecimiento que recibe:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.establecimiento_recibe_nombre.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Actividad recibe:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.actividad_recibe.descripcion.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
            </div>

            {this.props.bitacora_movimiento &&
            this.props.bitacora_movimiento.actividad_recibe_id === "16" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Número de factura:</label>
                    <div className="form-control">
                      {this.props.bitacora_movimiento
                        ? this.props.bitacora_movimiento
                            .bitacora_producto_detalle_entrada.num_factura ??
                          "N/A"
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* </div> */}
          </fieldset>

          <fieldset>
            <legend>DATOS PRODUCTO</legend>
            <div className="row">
              <div className="col-lg-2">
                <div className="form-group">
                  <label>Número de registro:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.producto.no_registro
                      : "N/A"}
                  </div>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="form-group">
                  <label>Nombre comercial:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.bitacora_producto_egreso
                          .producto_nombre_comercial
                      : null}
                  </div>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="form-group">
                  <label>Presentación:</label>
                  <div className="form-control">
                    {this.props.bitacora_movimiento
                      ? this.props.bitacora_movimiento.bitacora_producto_egreso
                          .rel_producto_empaque_texto
                      : null}
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-lg-12">
                <table className="table table-striped mb-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Lote</th>
                      <th className="text-center">Fecha fabricación</th>
                      <th className="text-center">Vencimiento lote</th>
                      <th className="text-center">Cantidad enviada</th>
                      <th className="text-center">Cantidad aceptada</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.bitacora_movimiento &&
                    this.props.bitacora_movimiento.rel_bitacora_producto_lote
                      .length > 0
                      ? this.props.bitacora_movimiento.rel_bitacora_producto_lote.map(
                          (item, index) => (
                            <tr key={index}>
                              <td className="text-center" width={"20%"}>
                                {item.num_lote}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.fecha_fabricacion
                                  .split(" ")[0]
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.vencimiento_lote
                                  .split(" ")[0]
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.cantidad_enviada}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.cantidad_aceptada ?? "N/A"}
                              </td>
                            </tr>
                          )
                        )
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </fieldset>

          {this.props.bitacora_movimiento &&
          this.props.bitacora_movimiento.actividad_recibe_id === "16" ? (
            <fieldset>
              <legend>DOCUMENTOS</legend>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Vista previa</th>
                      <th className="text-center">Documento</th>
                      <th className="text-center">Fecha carga</th>
                      <th className="text-center">Fecha aprobación</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        <img
                          alt="Vista previa"
                          className="rounded btn"
                          data-file={
                            Api.url +
                            `app/documentoMP/?id=${
                              this.props.bitacora_movimiento.id ?? null
                            }`
                          }
                          onClick={this.props.handlePrevia}
                          width="60"
                          src={
                            Api.url +
                            `app/documentoMP/?id=${
                              this.props.bitacora_movimiento.id ?? null
                            }&thumb=1`
                          }
                        />
                      </td>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        {this.props.bitacora_movimiento.tipo_documento.descripcion.toUpperCase()}
                      </td>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        {this.props.bitacora_movimiento
                          .bitacora_producto_detalle_entrada.created !== null
                          ? this.props.bitacora_movimiento.bitacora_producto_detalle_entrada.created
                              .substr(0, 10)
                              .split("-")
                              .reverse()
                              .join("/")
                          : "N/A"}
                      </td>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        {this.props.bitacora_movimiento.solicitud
                          .fecha_aprueba_sinaip
                          ? this.props.bitacora_movimiento.solicitud.fecha_aprueba_sinaip
                              .split("-")
                              .reverse()
                              .join("-")
                              .replaceAll("-", "/")
                          : "N/A"}
                      </td>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div className="btn-group">
                          <a
                            href={
                              Api.url +
                              `app/documentoMP/?id=${
                                this.props.bitacora_movimiento.id ?? null
                              }&download=1`
                            }
                            className="btn btn-primary"
                          >
                            <i className="fas fa-file-download"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
          ) : null}

          <fieldset>
            <legend>OBSERVACIONES</legend>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <textarea
                    name="observaciones"
                    id="observaciones"
                    className="form-control"
                    readOnly
                    // onChange={this.handleObservation}
                    value={
                      this.props.bitacora_movimiento &&
                      this.props.bitacora_movimiento.observaciones
                        ? this.props.bitacora_movimiento.observaciones
                        : "N/A"
                    }
                    placeholder="Ingrese observaciones"
                  ></textarea>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </>
    );
  }
}

export default InfoForm;
